import { apiResourceUrl } from "@ploy-lib/core";
import { Entity } from "@rest-hooks/rest";
import { BaseCamelCasedResource } from "./BaseResource";
export class LimitRedistributionLimitDetailEntity extends Entity {
    constructor() {
        super(...arguments);
        this.applicationId = undefined;
        this.applicationNumber = undefined;
        this.applicationStatus = undefined;
        this.objectGroup = undefined;
        this.objectCondition = undefined;
        this.limitApplicationNumber = undefined;
        this.limitGuid = undefined;
    }
    pk(parent, key) {
        return this.applicationId?.toString();
    }
}
export class LimitRedistributionResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.customerId = 0;
        this.limitGuid = "";
        this.customerAgreements = [];
        this.applications = [];
    }
    pk() {
        return this.customerId.toString() || "";
    }
}
LimitRedistributionResource.schema = {
    applications: [LimitRedistributionLimitDetailEntity]
};
LimitRedistributionResource.urlRoot = apiResourceUrl("limit-redistribution");
//# sourceMappingURL=LimitRedistributionResource.js.map